import React from 'react';

// Helper functions for icons and colors
function getBackgroundColor(iconKey) {
  const bgColorMap = {
    totalPlays: 'bg-indigo-100 text-indigo-500',
    audience: 'bg-green-100 text-green-500',
    analytics: 'bg-purple-100 text-purple-500',
    addEpisode: 'bg-orange-100 text-orange-500',
  };
  return bgColorMap[iconKey] || 'rgba(99, 102, 241, 0.1)';
}

function getIconText(iconKey) {
  const iconMap = {
    totalPlays: '▶',
    audience: '👥',
    analytics: '📊',
    addEpisode: '➕',
  };
  return iconMap[iconKey] || '📊';
}

const AnalyticsCard = ({ iconKey, title, subtitle, onClick }) => {
  return (
    <div
      className="card h-100"
      style={{
        borderRadius: '12px',
        border: '1px solid #E0E0E0',
        cursor: 'pointer',
        boxShadow: 'none',
      }}
      onClick={onClick}
    >
      <div className="card-body">
        <div className="d-flex flex-column" style={{ gap: '16px' }}>
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: getBackgroundColor(iconKey),
              color: '#6366f1',
            }}
          >
            <span style={{ fontSize: '24px' }}>{getIconText(iconKey)}</span>
          </div>
          <h6 className="card-title mb-0" style={{ fontWeight: 600 }}>
            {title}
          </h6>
          <p className="card-text text-muted mb-0" style={{ fontSize: '14px' }}>
            {subtitle}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsCard;
